import { pick } from "lodash";

import { ChartSettings } from "@/classes/BaseChart/index";
import { displaySettingsNames } from "@/settings/charts";

class ChartWithData {
  declare settings: ChartSettings;

  private cleanData(data: Record<string, unknown>[]): Record<string, unknown>[] {
    return data.map((item: Record<string, unknown>) => pick(item, [...this.chartDataFields()]));
  }

  protected chartDataFields(): string[] {
    const existingSettings = Object.keys(this?.settings || {}).filter((key) => displaySettingsNames.includes(key));

    return existingSettings.map((settingName) => this.settings[settingName]);
  }
}

export default ChartWithData;
